var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"issuable-sidebar-header"},[_c('toggle-sidebar',{attrs:{"collapsed":_vm.sidebarCollapsed,"css-classes":"gl-float-right"},on:{"toggle":function($event){return _vm.toggleSidebar({ sidebarCollapsed: _vm.sidebarCollapsed })}}}),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }